/**
 * Display symbol for API payloads (e.g. POST /mixed/sales-calc) — same intent as the meetor app
 * `symbol` on `ICalculateFees` (`$` for USD, not the ISO code).
 */
export function getCurrencyDisplaySymbol(currency: string): string {
  const code = currency?.trim();
  if (!code) return '$';
  const upper = code.toUpperCase();
  try {
    const parts = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: upper,
    }).formatToParts(0);
    const cur = parts.find((p) => p.type === 'currency');
    if (cur?.value) return cur.value;
  } catch {
    // invalid currency code
  }
  return upper;
}
